<template>
    <div>
        <div v-if="showMenu" class="menu-container">
            <span @click="tab = 0" :class="{ active: tab === 0 }">Obecności</span>
            <span @click="tab = 1" :class="{ active: tab === 1 }">Kadra</span>
            <span @click="tab = 2" :class="{ active: tab === 2 }">Struktura</span>
        </div>

        <transition name="component-fade" mode="out-in">
            <EmployeeViewSwap 
                v-if="tab === 0" 
                @toggleMenuVisibility="toggleMenuVisibility"
            />
            <ActiveEmployees v-else-if="tab === 1"/>
            <Structure v-else-if="tab === 2"/>
        </transition>

    </div>
</template>

<script>
import EmployeeViewSwap from './EmployeeViewSwap.vue';
import ActiveEmployees from './ActiveEmployees.vue';
import Structure from './Structure.vue';

export default {
    name: 'Employees',
    data() {
        return {
            showMenu: true,
            tab: 0,
        }
    },
    components: {
        ActiveEmployees,
        Structure,
        EmployeeViewSwap
    },
    methods: {
        toggleMenuVisibility() {
            this.showMenu = !this.showMenu
        }
    }
}
</script>

<style scoped>
.component-fade-enter-active,
.component-fade-leave-active {
    transition: opacity .3s ease;
}

.component-fade-enter,
.component-fade-leave-to {
    opacity: 0;
}

.menu-container {
    display: flex;
    width: 100%;
    max-width: 36rem;
    column-gap: .5rem;
    border-radius: .25rem;
    background: linear-gradient(to bottom, #e9e9e9 0%, #ddd 100%);
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1rem;
    color: rgba(0, 0, 0, 0.5);
}

.menu-container span {
    cursor: pointer;
    width: 100%;
    text-align: center;
    padding: .5rem;
}

.menu-container span:hover:not(.active) {
    color: rgba(0, 0, 0, 0.7)
}

.active {
    color: #ff6200;
}
</style>


// WEBPACK FOOTER //
// Employees.vue?b259719a